import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import TableTab from "../../tabs/table-tab";
import { WizardStepLayout } from '../../wizard/wizard-summary-layout';
import { getDateCategory, NameOnlyColumn } from "../filterModalUtil";
import { FilterModel } from "../FilterModel";
import { ListData } from "../../../models/ListData";
import { ListQuery } from "../../../models/ListQuery";
import { DEF_PG_SIZE_SUB_MIN } from "../../../constants/maximum-page-size";

interface CategoryProps {
    onNext: (event: any) => void ;
    onBack: (event: any) => void;
    categoryFilter?: FilterModel;
    filterModalTrigger: string;
    categoryDataMethod?: (translate: any, filter?: FilterModel, listParameters?: ListQuery) => Promise<ListData>;
}

export const Category: FC<CategoryProps> = ({ onBack, onNext, categoryFilter, filterModalTrigger, categoryDataMethod }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.selectAFilterTypeCategory);
    const dataMethod = categoryDataMethod ?? getDateCategory;
    const { values, setFieldValue } = useFormikContext<any>();
    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }

    useEffect(() => { 
        dataRefresh((listParameters) => dataMethod(translate, categoryFilter, listParameters));
    }, [categoryFilter, categoryDataMethod]);

    const onRowClicked = (rowData: any) => {
        const fakeOnclickEvent = {} as React.MouseEvent<HTMLButtonElement, MouseEvent>
        const eventWithData = { ...fakeOnclickEvent, elementSysname: rowData.elementSysname, name: rowData.nameOriginal };
        setFieldValue('categoryElementSysname',rowData.elementSysname);
        onNext(eventWithData);
    }

    return <WizardStepLayout onBack={!filterModalTrigger ? onBack : undefined} onNext={onNext} nextDisabled={!values.categoryElementSysname}>
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                usePagination
                useTable
                dataMethod={(listParameters) => dataMethod(translate, categoryFilter, listParameters )}
                tableDescriptor={NameOnlyColumn}
                manualDataRefresh={manualDataRefresh}
                disableSearch={false}
                useSearch={true}
                maxPageSize={DEF_PG_SIZE_SUB_MIN}>
                <TableTab
                    title={title}
                    tableHeight="100%"
                    selectRows={false}
                    onRowClicked={(data) => onRowClicked(data)}
                    tableId={'filterCategoryTable'}
                    cyName="categoryStep" />
            </TableContextProvider>
        </div>
    </WizardStepLayout>
}